module.exports = __webpack_public_path__ + "static/media/bag-alt.29f0d48e.svg";